import { Card, Text, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';
import { CartOutlinedSize24 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelectorNonNullable } from 'src/hooks/useSelector';

import PriceCartContentSwitcher from 'src/components/Price/PriceCart/PriceCartContentSwitcher';
import PriceCartFooter from 'src/components/Price/PriceCart/PriceCartFooter';

import styles from './price-cart.less';

const TrlKeys = {
    empty: 'employer.price.cart.empty',
};

const PriceCart: TranslatedComponent = ({ trls }) => {
    const products = useSelectorNonNullable(({ priceCart }) => priceCart.products);

    const { isGtM } = useBreakpoint();

    if (!isGtM) {
        return null;
    }

    return (
        <Card borderWidth="default" padding={12} borderRadius={24} data-qa="cart" stretched>
            {products.length === 0 ? (
                <div className={styles.cartPlaceholder} data-qa="cart__title_empty">
                    <div className={styles.cartPlaceholderIconWrapper}>
                        <CartOutlinedSize24 initialColor="secondary" />
                    </div>
                    <VSpacing default={12} />
                    <Text style="secondary" typography="label-3-regular">
                        {trls[TrlKeys.empty]}
                    </Text>
                </div>
            ) : (
                <>
                    <div className={styles.cartWrapper}>
                        <PriceCartContentSwitcher />
                    </div>
                    <PriceCartFooter />
                </>
            )}
        </Card>
    );
};

export default translation(PriceCart);
